import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50" aria-label="漫画分类导航">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">分类浏览</h2>
          <p className="text-sm text-foreground-500 mt-2">选择你喜欢的漫画类型，发现更多精彩内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}